import Button from '@/components/common/Button';
import {Select, TextArea} from '@/components/common/Input';
import type {ModalProps} from '@/components/Modals';
import Modal from '@/components/Modals';
import {
  AfriexBlockReasonsMap,
  AfriexUnblockReasonsMap,
} from '@/constants/formatters';
import type {AdminAfriexPerson} from '@/types';

interface BlockUserModalProps extends Omit<ModalProps, 'title'> {
  user: AdminAfriexPerson;
  isLoading: boolean;
  onSubmit: () => void;
  securityNote: string;
  handleSecurityNoteChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  handleBlockReason: (val: string) => void;
  handleUnblockReason: (val: string) => void;
  unblockReason: string;
  blockReason: string;
}

export function BlockUserModal({
  user,
  isLoading,
  onClose,
  onSubmit,
  securityNote,
  handleSecurityNoteChange,
  handleBlockReason,
  blockReason,
  unblockReason,
  handleUnblockReason,
  isOpen,
}: BlockUserModalProps) {
  const securityLabel = user.isSecurityFlagged ? 'Unblock' : 'Block';
  const label = `${securityLabel} ${user.name.firstName}`;
  const hasReason = Boolean(blockReason || unblockReason);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="w-10/12 sm:w-10/12 md:w-7/12 lg:w-4/12"
      title={label}
    >
      <>
        <h3 className="text-sm">Enter security note to {label}</h3>
        <div className="text-sm font-light mt-3">
          <TextArea
            name="securityNote"
            required
            onChange={handleSecurityNoteChange}
            value={securityNote || ''}
            aria-rowspan={5}
            type="text"
            className="w-full isFull"
            placeholder={`${label} because ...`}
          />
        </div>

        <div className="mt-5">
          <Select
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              user.isSecurityFlagged
                ? handleUnblockReason(e.target.value)
                : handleBlockReason(e.target.value)
            }
            value={user.isSecurityFlagged ? unblockReason : blockReason}
            options={
              user.isSecurityFlagged
                ? AfriexUnblockReasonsMap
                : AfriexBlockReasonsMap
            }
            name="reason"
            placeholder={`Select ${user.isSecurityFlagged ? 'Unblock' : 'Block'} reason`}
            label="Select Reason"
          />
        </div>

        <div className="flex w-full justify-end space-x-2 py-5">
          <Button onClick={onClose} variant="outline" colorScheme="cyan">
            cancel
          </Button>
          <Button
            disabled={isLoading || !securityNote || !hasReason}
            onClick={onSubmit}
            colorScheme={user.isSecurityFlagged ? 'orange' : 'red'}
          >
            {label}
          </Button>
        </div>
      </>
    </Modal>
  );
}
